import { createSvgComponent } from "../../icon/createSvgComponent";
import DirectApply from "@core/icon/assets/direct-apply.svg";
export default createSvgComponent(DirectApply);